import { Breadcrumbs } from "../../Home/Breadcrumb"
import { BuscarEquipamiento } from "./Buscar";
import TableEquipamiento from "./Table";
import { ToastContainer } from "react-toastify";

export const Equipamiento = () => {
    return (
        <>
            <ToastContainer />

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <Breadcrumbs
                            title={'Equipamiento'}
                            nameFirst={'Configuración'}
                            urlFirst={'/'}
                        />

                        <BuscarEquipamiento />
                        <TableEquipamiento />
                    </div>
                </div >
            </div >
        </>
    )
}
